/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, location: NonNullable<unknown> }} Coinvestments_Dataroom_Folderaddedtolocation5Inputs */

const en_coinvestments_dataroom_folderaddedtolocation5 = /** @type {(inputs: Coinvestments_Dataroom_Folderaddedtolocation5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} folder added to ${i?.location}`)
};

/**
* | output |
* | --- |
* | "{count} folder added to {location}" |
*
* @param {Coinvestments_Dataroom_Folderaddedtolocation5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_folderaddedtolocation5 = /** @type {((inputs: Coinvestments_Dataroom_Folderaddedtolocation5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Folderaddedtolocation5Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_folderaddedtolocation5(inputs)
});
export { coinvestments_dataroom_folderaddedtolocation5 as "coInvestments_dataRoom_folderAddedToLocation" }